export default function(text: string, emptyText = "-"): string {
  return text ? text : emptyText;
}
